
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/living/about",
      function () {
        return require("private-next-pages/living/about.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/living/about"])
      });
    }
  